export default {"src":"/_next/static/media/logo-short.5d7bae6f.svg","height":48,"width":48};